export let newsFilter = {
	yearSelector: null,
	categorySelector: null,
	init: function(){
		newsFilter.yearSelector 	= document.querySelector(".c-years_selector select");
		if( newsFilter.yearSelector ){
			newsFilter.categorySelector = document.querySelector(".c-news_categories select");
			newsFilter.check();
			newsFilter.nav();
		}
	},
	nav: function(){
		newsFilter.yearSelector.removeEventListener("change", newsFilter.changeYear, false);
		newsFilter.yearSelector.addEventListener("change", newsFilter.changeYear, false);
		
		newsFilter.categorySelector.removeEventListener("change", newsFilter.changeCategory, false);
		newsFilter.categorySelector.addEventListener("change", newsFilter.changeCategory, false);
	},
	changeYear: function(e){
		let val 	= newsFilter.yearSelector.value;
		let path 	= getPath(location.pathname);
		let url 	= `${path}${val}/`;
		if( val === "all" ){
			url 	= `${path}`;
		}
		location.href = url;
	},
	changeCategory: function(){
		let val 	= newsFilter.categorySelector.value;
		let path 	= getPath(location.pathname);
		let url 	= `${path}category/${val}/`;
		if( val === "" ){
			url 	= `${path}`;
		}
		location.href = url;
	},
	check: function(){
		let path 	= location.pathname;
		let arry 	= path.split("/");
		let isFilterBy = getNewsFilterType(path);
		if( isFilterBy === "year" ){
			newsFilter.yearSelector.value = arry[arry.length - 2];
		}else if(isFilterBy === "category" ){
			newsFilter.categorySelector.value = arry[arry.length - 2];
		}
	}
}

const getPath = (path)=> {
	const segments = path.split('/').filter(Boolean);
	const newsIndex = segments.indexOf('news');
	// news以前のセグメント + news をつなげる
	return '/' + segments.slice(0, newsIndex + 1).join('/') + '/';
}
function getNewsFilterType(path) {
	const segments = path.split('/').filter(Boolean);
	const newsIndex = segments.indexOf('news');
	const next = segments[newsIndex + 1]; // news/ の次のセグメント
	
	if (!next) return null; // /news/ トップ
	
	if (/^\d{4}$/.test(next)) return 'year';
	if (next === 'category') return 'category';
	
	return null;
}